// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filesDropZone {
    display: flex;
    flex-direction: column;
    background-color: #eeeeee;
    border: 1px solid #9e9e9e;
    height: 120px;
    line-height: 120px;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    transition: all 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.filesDropZone__fileAppendInput {
    visibility: hidden;
    height: 0;
    width: 0;
}

.filesDropZone:hover,
.filesDropZone--hover {
    background-color: #f5f5f5f5;
    border: 1px solid #bdbdbd;
    cursor: pointer;
}

.filesDropZone__icon {
    height: 50px;
    width: 50px;
    color: var(--public-portal-primary);
    opacity: 1;
    transition: all 300ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.filesDropZone__text {
    display: inline-block;
}

.filesDropZone:hover .filesDropZone__icon,
.filesDropZone--hover .filesDropZone__icon,
.filesDropZone__icon:hover {
    cursor: pointer;
    opacity: 0.7;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/dragAndDrop/DragAndDropFiles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,wDAAwD;AAC5D;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,UAAU;IACV,qBAAqB;IACrB,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".filesDropZone {\n    display: flex;\n    flex-direction: column;\n    background-color: #eeeeee;\n    border: 1px solid #9e9e9e;\n    height: 120px;\n    line-height: 120px;\n    border-radius: 4px;\n    align-items: center;\n    justify-content: center;\n    transition: all 300ms;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.filesDropZone__fileAppendInput {\n    visibility: hidden;\n    height: 0;\n    width: 0;\n}\n\n.filesDropZone:hover,\n.filesDropZone--hover {\n    background-color: #f5f5f5f5;\n    border: 1px solid #bdbdbd;\n    cursor: pointer;\n}\n\n.filesDropZone__icon {\n    height: 50px;\n    width: 50px;\n    color: var(--public-portal-primary);\n    opacity: 1;\n    transition: all 300ms;\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.filesDropZone__text {\n    display: inline-block;\n}\n\n.filesDropZone:hover .filesDropZone__icon,\n.filesDropZone--hover .filesDropZone__icon,\n.filesDropZone__icon:hover {\n    cursor: pointer;\n    opacity: 0.7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
